import { Component } from "@angular/core";
import { MatDivider } from "@angular/material/divider";

@Component({
    selector: "app-divider",
    template: `<mat-divider class="w-75 mx-auto divider-light" /> `,
    styles: [
        `span {}`
    ],
    imports: [MatDivider]
})
export class DividerComponent {}
